import React from 'react';
import Section from '../MyProfile/Section';
import TextInput from '../Form/TextInput/TextInput';
import {formatProductTerm, formatDate} from '../../utils/helpers';
import {formatCurrency} from '../../utils/helpers';
import withFeatureFlags from '../FeatureFlags/withFeatureFlags';

/** @import {FisaProductData} from './MyAccountTypes' */

function formatter(/** @type {Date | undefined} */ date) {
    if (date) {
        return formatDate(new Date(date));
    }

    return '';
}

function FisaTerm(/** @type {{profileData: FisaProductData}} */  props) {
    const profile = props.profileData;
    const title = profile.maturingAccount && (profile.maturingAccount.maturity?.maturityInstructionWindowStatus === "InstructionOpen" || profile.maturingAccount.maturity?.maturityInstructionWindowStatus === "InstructionClosed") ? "Current term" : "Term";
    const term = profile.productTerm
        ? formatProductTerm(profile.productTerm)
        : '1 year';
    return (
        <Section title={title} hideEditing={true}>
            {
                profile.maturingAccount &&
                (profile.maturingAccount.maturity?.maturityInstruction === "RolloverPayawayInterest" ||
                    profile.maturingAccount.maturity?.maturityInstruction === "RolloverPartialFundPayoutInterest") &&
                <TextInput className="my-account__input" value={formatCurrency(profile.maturingAccount.maturity.calculatedBalanceAtMaturity - profile.maturingAccount.balance)} label='Interest earned on maturity' disabled/>
            }
            <TextInput className="my-account__input" value={term} label='Length' disabled/>
            <TextInput className="my-account__input" value={formatter(profile.fundingStartDate)} label='Start' disabled/>
            {profile.maturityDate &&
                <TextInput className="my-account__input" value={formatter(profile.maturityDate)} label='End' disabled/>
            }
        </Section>
    )
}

export default withFeatureFlags(FisaTerm);